import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <p><b>Zig Zag Example: Presentations</b></p>
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/cope_up_img1.png')}
                                                    alt=""/>

                                            </div>


                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>

                                            <p>This tool is designed to focus your thoughts on how you cope with
                                                setbacks. Consider the
                                                following suggestions for practical next steps (although these
                                                are by no means exhaustive):</p>
                                            <div className="border_subtitle">Use the exercises in this tool
                                            </div>
                                            <p>Use the zig zag model to help you to cope with setbacks. Try and
                                                find opportunities to practise it.
                                                Use the ‘significant life events’ exercise to help you to think
                                                about how you have dealt with
                                                different situations.</p>
                                            <div className="border_subtitle">Discuss how you cope with
                                                setbacks
                                            </div>
                                            <p>Consider discussing these findings with someone you trust, such
                                                as a line manager, coach,
                                                mentor, colleague or even friends and family to gain different
                                                perspectives and to consider your
                                                way forward.</p>
                                            <div className="border_subtitle">Seek out role models</div>
                                            <p>Do you know someone who seems to cope well with setbacks? Think
                                                about what it is that you
                                                admire about them or their approach – and then compare yourself
                                                with them. The differences
                                                may at first seem too great, but it’s a start and could reveal
                                                aspects of your own approach of
                                                which you were previously unaware.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>If you don’t already have a personal development plan it’s worth
                                                the time spent creating one.
                                                Make sure to set yourself clear objectives and practical things
                                                to do to help make a real
                                                improvement. For a start, this will indicate how much your
                                                attitude and ability to deal with setbacks
                                                has improved.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}